import { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute, DomainRedirect } from '../../../utils/domain/routingComponents'
import { enterpriseStatusPageAccessControl } from '../access-control/enterpriseStatusPageAccess.configuration'

const EnterpriseStatusPage = lazy(() => import('../pages/EnterpriseStatusPage'))

const CreateIncidentPage = lazy(() => import('../pages/CreateIncidentPage'))

export const enterpriseStatusPageAdminRouter = (
  <DomainRoute
    route="app-admin-enterprise-status-page"
    accessControl={enterpriseStatusPageAccessControl}
  >
    <DashSwitch>
      <DomainRoute
        exact
        route="app-admin-enterprise-status-page-create-incident"
        component={CreateIncidentPage}
      />
      <DomainRoute
        exact
        route="app-admin-enterprise-status-page"
        component={EnterpriseStatusPage}
      />
      <DomainRedirect toRoute="app-admin-enterprise-status-page" />
    </DashSwitch>
  </DomainRoute>
)
